export const ChainIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_195_23136'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='1'
      y='2'
      width='18'
      height='16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.125 5.3125C3.125 4.44956 3.82456 3.75 4.6875 3.75C5.55044 3.75 6.25 4.44956 6.25 5.3125C6.25 6.17544 5.55044 6.875 4.6875 6.875C3.82456 6.875 3.125 6.17544 3.125 5.3125ZM4.6875 2.5C3.1342 2.5 1.875 3.7592 1.875 5.3125C1.875 6.67316 2.84124 7.80815 4.125 8.06874V10C4.125 13.1066 6.6434 15.625 9.75 15.625H12.66C13.0461 16.7174 14.0879 17.5 15.3125 17.5C16.8658 17.5 18.125 16.2408 18.125 14.6875C18.125 13.1342 16.8658 11.875 15.3125 11.875C13.8648 11.875 12.6726 12.9688 12.5172 14.375H9.75C7.33376 14.375 5.375 12.4162 5.375 10V8.04037C6.59597 7.73362 7.5 6.62863 7.5 5.3125C7.5 3.7592 6.2408 2.5 4.6875 2.5ZM15.3125 13.125C14.4496 13.125 13.75 13.8246 13.75 14.6875C13.75 15.5504 14.4496 16.25 15.3125 16.25C16.1754 16.25 16.875 15.5504 16.875 14.6875C16.875 13.8246 16.1754 13.125 15.3125 13.125Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_195_23136)'>
      <path d='M20 0H0V20H20V0Z' fill='#808080' />
    </g>
  </svg>
)
